import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import { Typography, Paper } from '@mui/material';
import styles from './styles.module.scss';

import EmailConfirmIcon from '@/assets/icons/LetterConfirm.svg';

export const EmailConfirm: FC = () => {
  const { t } = useTranslation('optOut');
  return (
    <Paper className={styles.paper}>
      <Typography variant={'h3'} className={styles.title}>
        {t('confirmation.title')}
      </Typography>
      <Typography variant={'h4'} className={styles.description}>
        {t('confirmation.description')}
      </Typography>
      <EmailConfirmIcon className={styles.icon} />
    </Paper>
  );
};
